import React from 'react';
import './checkoutpage.css';
import salepicAurora from '../assets/AuroraSalePicSmall.png';
import salepicRefract from '../assets/RefractPromoImg3.jpg';
import salepicDuck from '../assets/DuckProduct2.jpg';

const BundleUpsell = ({ cart, onAddBundle }) => {
    // Determine what's currently in the cart
    const hasAurora = cart.some(item => item.id === 1);
    const hasRefract = cart.some(item => item.id === 2);
    const hasDuck = cart.some(item => item.id === 3);

    // If they already have all three, they have the ultimate bundle
    if (hasAurora && hasRefract && hasDuck) {
        return (
            <div className="bundleupsell__container bundleupsell__success">
                <div className="bundleupsell__successtext">
                    "Everything" Bundle Discount Applied!
                </div>
            </div>
        );
    }

    // Determine the optimal complimentary product to offer
    let offerProduct = null;
    let upsellMessage = "";

    // If they only have 1 item, suggest Refract or Aurora depending on what it is to drive a 2-bundle
    if (!hasAurora && !hasRefract && hasDuck) {
        offerProduct = { id: 2, name: 'Refract', price: 29.99, img: salepicRefract, originalPrice: 49.99 };
        upsellMessage = "Pair Duck with Refract to unlock the $39.99 Bundle!";
    } else if (hasAurora && !hasRefract && !hasDuck) {
        offerProduct = { id: 2, name: 'Refract', price: 29.99, img: salepicRefract, originalPrice: 49.99 };
        upsellMessage = "Unlock the $44.99 Bundle by adding Refract!";
    } else if (!hasAurora && hasRefract && !hasDuck) {
        offerProduct = { id: 1, name: 'Aurora', price: 29.99, img: salepicAurora, originalPrice: 49.99 };
        upsellMessage = "Unlock the $44.99 Bundle by adding Aurora!";
    } 
    // If they have 2 items, suggest the 3rd to drive the 'Everything' 3-bundle ($54.99)
    else if (hasAurora && hasRefract && !hasDuck) {
        offerProduct = { id: 3, name: 'Duck', price: 19.99, img: salepicDuck, originalPrice: 29.99 };
        upsellMessage = "Complete the collection! Add Duck to get the 'Everything' bundle for just $10 more!";
    } else if (hasRefract && hasDuck && !hasAurora) {
        offerProduct = { id: 1, name: 'Aurora', price: 29.99, img: salepicAurora, originalPrice: 49.99 };
        upsellMessage = "Get the 'Everything' bundle! Add Aurora for only $15 more!";
    } else if (hasAurora && hasDuck && !hasRefract) {
        offerProduct = { id: 2, name: 'Refract', price: 29.99, img: salepicRefract, originalPrice: 49.99 };
        upsellMessage = "Complete the toolkit! Add Refract to secure the massive 'Everything' discount!";
    }

    if (!offerProduct) return null;

    return (
        <div className="bundleupsell__container">
            <div className="bundleupsell__badge">Special Offer</div>

            <div className="bundleupsell__content">
                <img src={offerProduct.img} alt={offerProduct.name} className="bundleupsell__img" />

                <div className="bundleupsell__info">
                    <div className="bundleupsell__title">{upsellMessage}</div>
                    <div className="bundleupsell__subtitle">Usually ${offerProduct.originalPrice}. Secure your massive discount now.</div>
                </div>

                <div className="bundleupsell__action">
                    <button
                        className="bundleupsell__addbtn"
                        onClick={() => onAddBundle(offerProduct.id, offerProduct.name, offerProduct.price, offerProduct.originalPrice, offerProduct.img)}
                    >
                        + Add {offerProduct.name}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BundleUpsell;
